"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _BETServiceObjectsStore = _interopRequireDefault(require("crm_ui/BET/engagementAssociations/stores/BETServiceObjectsStore"));

var _LoadingStatus = require("crm_data/constants/LoadingStatus");

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var BETServiceObjectsAssociationOptionsDependency = {
  propTypes: {
    subject: _SubjectType.default.isRequired
  },
  stores: [_BETServiceObjectsStore.default],
  deref: function deref(props) {
    var subject = props.subject;
    var objectType = (0, _ImmutableModel.getObjectType)(subject);
    var subjectId = (0, _ImmutableModel.getId)(subject);

    if (!objectType || !subjectId) {
      return _LoadingStatus.LOADING;
    }

    if (!_ScopesContainer.default.isScoped('bet-deliverable-service-association-access') || objectType !== _ObjectTypes.CONTACT) {
      return [];
    }

    var options = _BETServiceObjectsStore.default.get((0, _immutable.Map)({
      objectType: objectType,
      subjectId: subjectId
    }));

    if (!options) {
      return _LoadingStatus.LOADING;
    }

    return options.map(function (option) {
      return {
        text: option.get('label'),
        value: option.get('objectId')
      };
    }).toArray();
  }
};
var _default = BETServiceObjectsAssociationOptionsDependency;
exports.default = _default;
module.exports = exports.default;